import { render, staticRenderFns } from "./DesktopMainNavItem.vue?vue&type=template&id=2e83d110&scoped=true&"
import script from "./DesktopMainNavItem.vue?vue&type=script&lang=js&"
export * from "./DesktopMainNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e83d110",
  null
  
)

export default component.exports